/**
 * 数据统计表格（线下主楼数据）
 * 
 */
import React from 'react';
import { Row, Col, Select,Radio,DatePicker } from 'antd';
import PageLayout from '../../ui/PageLayout';
//商户选择
import MemberSelect from '../../crm/member/MemberSelect';
import DictSelect from '../../ui/DictSelect';
import http from "../../../axios/http";
import { EchartBar } from '../../ui/chart/EchartBar'
import Loading from '../../ui/Loading';
import moment from 'moment';

const columns = [{
    title: '',
    dataIndex: 'dataType',
    width: '10%',
}
,{
    title: '入驻商户数量',
    dataIndex: 'members',
    width: '10%',
}
,{
    title: '在库台数',
    dataIndex: 'stockNum',
    width: '10%',
}
, {
    title: '环比',
    dataIndex: 'stockNumRatio',
    width: '10%',
}
, {
    title: '在库金额',
    dataIndex: 'stockPrice',
    width: '10%',
}
, {
    title: '环比',
    dataIndex: 'stockPriceRatio',
    width: '10%',
}
, {
    title: '已售台数',
    dataIndex: 'dealNum',
    width: '10%',
}
, {
    title: '环比',
    dataIndex: 'dealNumRatio',
    width: '10%',
}
,{
    title: '已售金额',
    dataIndex: 'dealPrice',
    width: '10%',
}
,{
    title: '环比',
    dataIndex: 'dealPriceRatio',
    width: '10%',
}
];

const bmColumns = [{
    title: '',
    dataIndex: 'typeName',
    width: '10%',
}
,{
    title: '名称',
    dataIndex: 'firstName',
    width: '10%',
}
,{
    title: '数量',
    dataIndex: 'firstNum',
    width: '10%',
}
, {
    title: '名称',
    dataIndex: 'secondName',
    width: '10%',
}
, {
    title: '数量',
    dataIndex: 'secondNum',
    width: '10%',
}
, {
    title: '名称',
    dataIndex: 'thirdName',
    width: '10%',
}
, {
    title: '数量',
    dataIndex: 'thirdNum',
    width: '10%',
}
];


class MallStockStatisticIndex extends React.Component {

    state = {
        loadData: '',
        queryData: {},
        resBrandData: [],//
        modelData:[],
        loadData2: '',

        typeBrandData:[],//类型品牌筛选数据
        typeModelData:[],//类型车型筛选数据
        vacantAmountChartData:[],
        //默认价格区间
        typeQueryData: {
            typeValue:2,
            startDate: moment().format("YYYY-MM-DD"),
            endDate: moment().format("YYYY-MM-DD"),
        },
        loadingVisible: false
        
    };

    componentWillMount() {
        this.setState({ loadingVisible: true });
        http.post({
            url: "/mall/stock/brand",
            data: null,
            success: (res) => {
                this.setState({ loadingVisible: false });
                //品牌排行
                let resBrandData= res;
                this.setState({
                    resBrandData:resBrandData,
                    typeBrandData:resBrandData
                });
            }
        })
    }

    componentDidMount(){
        this.loadTypeData(this.state.typeQueryData);
    }
    //查询
    loadTypeData = (typeQueryData) => {
        this.setState({ loadingVisible: true });
        http.get({
            url: "/mall/stock/svpData",
            data: typeQueryData,
            success: (res) => {
                this.setState({ loadingVisible: false });
                let monthList;
                if(this.state.typeQueryData.typeValue===1){
                    monthList=['1月内','1-2个月','2-3个月','3个月以上'];
                }else if(this.state.typeQueryData.typeValue===2){
                    monthList=['0-5万','5-10万','10-20万','20-30万','30-50万','50万以上'];
                }else if(this.state.typeQueryData.typeValue===3) {
                    monthList=['1年以内','1-3年','3-6年','6-10年','10-15年','15年以上'];
                }
                let vacantAmountChartData = this.getChartData('', 'bar', res, 'vacantAmountBar', monthList, "台");
                this.setState({
                    vacantAmountChartData:vacantAmountChartData
                });
                this.state.initChartBar1();
            }
        });
    }

    memberSelect = (res) => {
        let queryData = this.state.queryData;
        queryData.memberCode = res;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    typeMemberSelect = (res) => {
        let typeQueryData = this.state.typeQueryData;
        typeQueryData.memberCode = res;
        this.setState({ typeQueryData: typeQueryData });
        this.loadTypeData(typeQueryData);
    }

    onSelect = (field,value) => {
        let queryData = this.state.queryData;
        queryData[field] = value;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }
    //类型柱图下拉搜索
    typeOnSelect = (field,value) => {
        let typeQueryData = this.state.typeQueryData;
        typeQueryData[field] = value;
        this.setState({ typeQueryData: typeQueryData });
        this.loadTypeData(typeQueryData);
    }

    brandChange = (field, value) => {
        this.loadStockModel(this.state.resBrandData[value].brand)
        let queryData = this.state.queryData;
        queryData[field] = this.state.resBrandData[value].brand;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    typeBrandChange = (field, value) => {
        this.loadTypeStockModel(this.state.typeBrandData[value].brand)
        let typeQueryData = this.state.typeQueryData;
        typeQueryData[field] = this.state.typeBrandData[value].brand;
        this.setState({ typeQueryData: typeQueryData });
        this.loadTypeData(typeQueryData);
    }

    modelChange = (field, value) => {
        let queryData = this.state.queryData;
        queryData[field] = this.state.modelData[value].model;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    typeModelChange = (field, value) => {
        let typeQueryData = this.state.typeQueryData;
        typeQueryData[field] = this.state.typeModelData[value].model;
        this.setState({ typeQueryData: typeQueryData });
        this.loadTypeData(typeQueryData);
    }


    //切换库龄、价格、车龄
    handleSizeChange = e => {
        let typeQueryData = this.state.typeQueryData;
        typeQueryData.typeValue=e.target.value;
        this.setState({
            typeQueryData: typeQueryData,
        });
        this.loadTypeData(typeQueryData)
    };

    typeRangePickerChange = (dates, dateStrings) => {
        let typeQueryData = this.state.typeQueryData;
        typeQueryData.startDate = dateStrings[0];
        typeQueryData.endDate = dateStrings[1];
        this.setState({ typeQueryData: typeQueryData });
        this.loadTypeData(typeQueryData);
    }

    getChartData = (name, type, rateList, id, xSeries, unit) => {
        let getData = [
            {
                name: name,
                type: type,
                data: rateList,
                itemStyle: {
                    normal: {
                        color: '#0096f3'
                    }
                },
                areaStyle: {},  // 折线下阴影背景
                label: {
                    normal: {
                        show: true,
                        position: 'top',
                        rotate: 45
                    }
                },

            }
        ];
        let optionData = {
            listData: getData,
            id: id,
            xSeries: xSeries,
            areaStyle: {},
            unit: unit
        };
        return optionData;
    }

    //查库存车车型
    loadStockModel(brand){
        this.setState({ loadingVisible: true });
        http.post({
        url: "/mall/stock/model",
        data: {brand:brand},
        success: (res) => {
            this.setState({ loadingVisible: false });
            this.setState({
                modelData:res
            });
        }
        })
    }

    //查库存车车型
    loadTypeStockModel(brand){
        this.setState({ loadingVisible: true });
        http.post({
            url: "/mall/stock/model",
            data: {brand:brand},
            success: (res) => {
                this.setState({ loadingVisible: false });
                this.setState({
                    typeModelData:res
                });
            }
        })
    }

    render() {
        return (
            <div style={{width: '100%', height: '100%', overflow: 'auto'}} id="big">
                {/* 在库、已售的台数、金额及其环比 */}
                <div style={{ width: '100%',height:'350px'}}>
                    <PageLayout
                        condition={(
                            <Row>
                                <Col span={24}>
                                    <MemberSelect mall={1} allowClear={true} placeholder="商户" onChange={this.memberSelect} style={{ width:'200px'}} />
                                    <DictSelect category="fuelType" allowClear={true} placeholder='能源类型' onChange={this.onSelect.bind(this,"newEnergy")} style={{ width: '200px', margin: '0 10px' }} />   
                                    <Select placeholder="品牌" onChange={this.brandChange.bind(this, "brand")} style={{ width: 200, marginRight: "10px" }}>
                                        {this.state.resBrandData.map(d =>
                                            <Select.Option key={d["id"]}>{d["brand"]}</Select.Option>
                                        )}
                                    </Select>
                                    <Select placeholder="型号" onChange={this.modelChange.bind(this, "model")} style={{ width: 200, marginRight: "10px" }}>
                                        {this.state.modelData.map(d =>
                                            <Select.Option key={d["id"]}>{d["model"]}</Select.Option>
                                        )}
                                    </Select>                               
                                </Col>
                            </Row>
                        )}
                        page={false}
                        rowKey="index"
                        url="/mall/stock/data"
                        requestType="get"
                        columns={columns}
                        loadData={(func) => { this.setState({ loadData: func }) }}
                    />
                </div>
                {/* 品牌车型排行 */}
                <div style={{ width: '100%',height:'300px',marginTop:'20px'}}>
                    <PageLayout
                        page={false}
                        rowKey="index"
                        url="/mall/stock/bmsdData"
                        requestType="get"
                        columns={bmColumns}
                        loadData2={(func) => { this.setState({ loadData2: func }) }}
                    />
                </div>
                <div style={{ width: '100%',height:'350px',marginTop:'20px'}}>
                    <Row>
                        <Col span={24}>
                            <MemberSelect mall={1} allowClear={true} placeholder="商户" onChange={this.typeMemberSelect} style={{ width:'200px'}} />
                            <DictSelect category="fuelType" allowClear={true} placeholder='能源类型' onChange={this.typeOnSelect.bind(this,"newEnergy")} style={{ width: '200px', margin: '0 10px' }} />   
                            <Select placeholder="品牌" onChange={this.typeBrandChange.bind(this, "brand")} style={{ width: 200, marginRight: "10px" }}>
                                {this.state.typeBrandData.map(d =>
                                    <Select.Option key={d["id"]}>{d["brand"]}</Select.Option>
                                )}
                            </Select>
                            <Select placeholder="型号" onChange={this.typeModelChange.bind(this, "model")} style={{ width: 200, marginRight: "10px" }}>
                                {this.state.typeModelData.map(d =>
                                    <Select.Option key={d["id"]}>{d["model"]}</Select.Option>
                                )}
                            </Select>
                            <DatePicker.RangePicker style={{ width: '300px'}} defaultValue={[moment(), moment()]} placeholder={["库存","时间"]} onChange={this.typeRangePickerChange} />                               
                        </Col>
                    </Row>
                    {this.state.vacantAmountChartData?<EchartBar
                        echartId={this.state.vacantAmountChartData.id}
                        echartData={this.state.vacantAmountChartData}
                        initChart={(func) => { this.setState({ initChartBar1: func }) }}
                    />:""}
                    <div style={{width:'100%',textAlign:'center'}}>
                        <Radio.Group onChange={this.handleSizeChange} value={this.state.typeQueryData.typeValue} >  
                            <Radio.Button value={1}>库龄（天）</Radio.Button>
                            <Radio.Button value={2}>价格区间</Radio.Button>
                            <Radio.Button value={3}>车龄区间</Radio.Button>
                        </Radio.Group>
                    </div>
                    
                </div>
                <Loading
                    visible={this.state.loadingVisible}
                    message="数据加载中"
                />
            </div>
            
            
        )
    }
}

export default MallStockStatisticIndex;